import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Transition as _Transition } from "vue"
import _imports_0 from '@/assets/images/icon_three-dots.svg'


const _hoisted_1 = { class: "c-popup__title" }
const _hoisted_2 = { class: "flex items-center gap-[28px]" }
const _hoisted_3 = {
  key: 1,
  class: "c-popup__footer"
}

import { ref, onMounted, onBeforeUnmount } from 'vue';
import BaseButton from '@/components/BaseButton.vue';
import { $t } from '@/plugins/translation';


export default /*@__PURE__*/_defineComponent({
  __name: 'BasePopup',
  props: {
  confirmButtonDisabled: {
    type: Boolean,
    default: false,
  },
  modelValue: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: 'title',
  },
  confirmText: {
    type: String,
    default: () => $t('common', 'confirm'),
  },
  closeText: {
    type: String,
    default: () => $t('common', 'cancel'),
  },
  classPopup: {
    type: String,
    default: '',
  },
  showFooter: {
    type: Boolean,
    default: true,
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  nonScroll: {
    type: Boolean,
    default: false,
  },
  onClose: Function,
  onConfirm: Function,
  canDrag: {
    type: Boolean,
    default: false,
  },
  canZoom: {
    type: Boolean,
    default: false,
  },
  showPopperOption: {
    type: Boolean,
    default: false,
  },
  initZoomState: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:modelValue', 'confirm', 'zoomIn'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;
const closePopup = () => {
  emit('update:modelValue', false);
  if (props.onClose) {
    props.onClose();
  }
};
const confirm = () => {
  emit('update:modelValue', false);
  if (props.onConfirm) {
    props.onConfirm();
  } else emit('confirm');
};

const isFullScreen = ref(props.initZoomState);

const myDivRef = ref(null);
const defaultStylePopup = {
  position: 'absolute',
  top: null,
  left: null,
};
const stylePopup = ref({ ...defaultStylePopup });

let pos1 = 0,
  pos2 = 0,
  pos3 = 0,
  pos4 = 0;

const dragMouseDown = (e) => {
  if (!props.canDrag) return;
  e.preventDefault();
  pos3 = e.clientX;
  pos4 = e.clientY;

  document.addEventListener('mousemove', elementDrag);
  document.addEventListener('mouseup', closeDragElement);
};

const elementDrag = (e) => {
  e.preventDefault();
  pos1 = pos3 - e.clientX;
  pos2 = pos4 - e.clientY;
  pos3 = e.clientX;
  pos4 = e.clientY;

  stylePopup.value.top = `${myDivRef.value.offsetTop - pos2}px`;
  stylePopup.value.left = `${myDivRef.value.offsetLeft - pos1}px`;
};

const closeDragElement = () => {
  document.removeEventListener('mouseup', closeDragElement);
  document.removeEventListener('mousemove', elementDrag);
};

// check device
const isMobile = ref(true);

const checkIsMobile = () => {
  isMobile.value = window.innerWidth < 767;
};

onMounted(() => {
  checkIsMobile();
  window.addEventListener('resize', checkIsMobile);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', checkIsMobile);
});

return (_ctx: any,_cache: any) => {
  const _component_VMenu = _resolveComponent("VMenu")!

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (__props.modelValue)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(`${__props.classPopup} c-popup ${isMobile.value ? 'mo' : ''}`)
          }, [
            _createElementVNode("div", {
              type: "button",
              class: "c-popup__dim",
              onClick: closePopup
            }),
            _createElementVNode("div", {
              class: _normalizeClass(`c-popup__inner ${isFullScreen.value ? '!max-h-[100%] !min-w-[100%] !max-w-[100%]' : ''}`),
              style: _normalizeStyle(stylePopup.value),
              ref_key: "myDivRef",
              ref: myDivRef
            }, [
              (__props.showHeader)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(`c-popup__header ${__props.canDrag ? 'cursor-grab' : ''}`),
                    onMousedown: dragMouseDown
                  }, [
                    _createElementVNode("span", _hoisted_1, _toDisplayString(__props.title), 1),
                    _createElementVNode("div", _hoisted_2, [
                      (__props.showPopperOption)
                        ? (_openBlock(), _createBlock(_component_VMenu, {
                            key: 0,
                            placement: "bottom-end"
                          }, {
                            popper: _withCtx(() => [
                              _renderSlot(_ctx.$slots, "popper-option")
                            ]),
                            default: _withCtx(() => [
                              _cache[1] || (_cache[1] = _createElementVNode("button", null, [
                                _createElementVNode("img", {
                                  class: "w-[20px] h-[20px] cursor-pointer",
                                  src: _imports_0
                                })
                              ], -1))
                            ]),
                            _: 3
                          }))
                        : _createCommentVNode("", true),
                      (__props.canZoom)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            onClick: _cache[0] || (_cache[0] = 
                () => {
                  stylePopup.value = { ...defaultStylePopup };
                  isFullScreen.value = !isFullScreen.value;
                  _ctx.$emit('zoomIn', isFullScreen.value);
                }
              )
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(`c-icon c-icon--${isFullScreen.value ? 'zoom-out' : 'zoom-in'}`)
                            }, _cache[2] || (_cache[2] = [
                              _createElementVNode("span", { class: "s-hide" }, "expand", -1)
                            ]), 2)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: closePopup
                      }, _cache[3] || (_cache[3] = [
                        _createElementVNode("i", { class: "c-icon c-icon--close" }, [
                          _createElementVNode("span", { class: "s-hide" }, "close")
                        ], -1)
                      ]))
                    ])
                  ], 34))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(`c-popup__body ${__props.nonScroll ? 'c-popup__body--none-scroll' : ''}`)
              }, [
                _renderSlot(_ctx.$slots, "default")
              ], 2),
              (__props.showFooter)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _renderSlot(_ctx.$slots, "footer", {}, () => [
                      _createVNode(BaseButton, {
                        color: "outline",
                        size: "small",
                        onClick: closePopup
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.closeText), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(BaseButton, {
                        size: "small",
                        onClick: confirm,
                        disabled: __props.confirmButtonDisabled
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.confirmText), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 6)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})